"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var SubModule_1 = require("../SubModule");

var types_1 = require("../../../types");

var procedures_1 = require("../../../procedures");

var __1 = require("../..");

var PolymathError_1 = require("../../../PolymathError");
/**
 * Namespace that handles all Offering related functionality
 */


var Offerings =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Offerings, _SubModule_1$SubModul);

  function Offerings() {
    var _this;

    _classCallCheck(this, Offerings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Offerings).apply(this, arguments));
    /**
     * Launch a Simple STO
     *
     * @param args.tokensOnSale - amount of tokens to be sold
     * @param args.rate - amount of tokens an investor can purchase per unit of currency spent
     * @param args.raisedFundsWallet - wallet address that will receive the funds that are being raised
     * @param args.unsoldTokensWallet - wallet address that will receive unsold tokens
     * @param args.allowPreIssuance - whether to have all tokens issued on STO start. Default behavior is to issue on purchase
     */

    _this.launchSimpleSto = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var context, securityToken, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context = this.context, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                procedure = new procedures_1.LaunchSimpleSto(Object.assign({
                  symbol: symbol
                }, args), context);
                return _context.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Launch a Tiered STO
     *
     * @param args.tiers - array that specifies how many tokens to sell at each tier (along with their price and potential discounts)
     * @param args.nonAccreditedInvestmentLimit - maximum investment for non-accredited investors
     * @param args.minimumInvestment - minimum investment amount
     * @param args.currencies - array of currencies in which the funds will be raised (ETH, POLY, StableCoin)
     * @param args.raisedFundsWallet - wallet address that will receive the funds that are being raised
     * @param args.unsoldTokensWallet - wallet address that will receive unsold tokens when the end date is reached
     * @param args.stableCoinAddresses - array of stable coins that the offering supports
     * @param args.customCurrency - allows the STO to raise funds pegged to a different currency. Optional, defaults to USD
     * @param args.allowPreIssuance - whether to have all tokens issued on STO start. Default behavior is to issue on purchase
     */


    _this.launchTieredSto = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var context, securityToken, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = this.context, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                procedure = new procedures_1.LaunchTieredSto(Object.assign({
                  symbol: symbol
                }, args), context);
                return _context2.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Retrieve an STO by type and address or UUID
     *
     * @param args - STO uuid or object containing its type and address
     */


    _this.getSto = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var stoType, address, _1$Sto$unserialize, factories, uid;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // fetch by UUID
                if (typeof args === 'string') {
                  _1$Sto$unserialize = __1.Sto.unserialize(args);
                  stoType = _1$Sto$unserialize.stoType;
                  address = _1$Sto$unserialize.address;
                } else {
                  stoType = args.stoType;
                  address = args.address;
                }

                factories = this.context.factories, uid = this.securityToken.uid;

                if (!(stoType === types_1.StoType.Simple)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", factories.simpleStoFactory.fetch(__1.SimpleSto.generateId({
                  securityTokenId: uid,
                  stoType: stoType,
                  address: address
                })));

              case 6:
                if (!(stoType === types_1.StoType.Tiered)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", factories.tieredStoFactory.fetch(__1.TieredSto.generateId({
                  securityTokenId: uid,
                  stoType: stoType,
                  address: address
                })));

              case 10:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "Invalid STO type \"".concat(stoType, "\"")
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Retrieve all STOs attached to a security token
     *
     * @param stoTypes - optional, defaults to both
     */


    _this.getStos = function () {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        stoTypes: [types_1.StoType.Simple, types_1.StoType.Tiered]
      };
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this$context, contractWrappers, factories, _this$securityToken, securityTokenSymbol, uid, stoTypes, stos, fetchedModules, addresses, _fetchedModules, _addresses;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;
                _this$securityToken = this.securityToken, securityTokenSymbol = _this$securityToken.symbol, uid = _this$securityToken.uid;
                stoTypes = opts.stoTypes;
                stos = [];

                if (!lodash_1.includes(stoTypes, types_1.StoType.Simple)) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 7;
                return contractWrappers.getAttachedModules({
                  symbol: securityTokenSymbol,
                  moduleName: contract_wrappers_1.ModuleName.CappedSTO
                }, {
                  unarchived: true
                });

              case 7:
                fetchedModules = _context4.sent;
                _context4.next = 10;
                return Promise.all(fetchedModules.map(function (module) {
                  return module.address();
                }));

              case 10:
                addresses = _context4.sent;
                stos = stos.concat(addresses.map(function (address) {
                  return factories.simpleStoFactory.fetch(__1.SimpleSto.generateId({
                    address: address,
                    stoType: types_1.StoType.Simple,
                    securityTokenId: uid
                  }));
                }));

              case 12:
                if (!lodash_1.includes(stoTypes, types_1.StoType.Tiered)) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 15;
                return contractWrappers.getAttachedModules({
                  symbol: securityTokenSymbol,
                  moduleName: contract_wrappers_1.ModuleName.UsdTieredSTO
                }, {
                  unarchived: true
                });

              case 15:
                _fetchedModules = _context4.sent;
                _context4.next = 18;
                return Promise.all(_fetchedModules.map(function (module) {
                  return module.address();
                }));

              case 18:
                _addresses = _context4.sent;
                stos = stos.concat(_addresses.map(function (address) {
                  return factories.tieredStoFactory.fetch(__1.TieredSto.generateId({
                    address: address,
                    stoType: types_1.StoType.Tiered,
                    securityTokenId: uid
                  }));
                }));

              case 20:
                return _context4.abrupt("return", Promise.all(stos));

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    return _this;
  }

  return Offerings;
}(SubModule_1.SubModule);

exports.Offerings = Offerings;